import { Form } from 'antd';
import React from 'react'
import FormNetworkProvider from './FormNetworkProvider';

const SearchNetworkProvider: React.FC<any> = ({
    getList,
    setPaginationData
}) => {
    const [form] = Form.useForm();
    const handleSearchSubmit = (data?: any) => {
        const payload = {
            ...data,
            pageNumber: 1,
            pageSize: 10,
        }
        setPaginationData({
            pageNumber: 1,
            pageSize: 10,
        })
        getList(payload)
    }
    return (
        <FormNetworkProvider
            form={form}
            handleSearchSubmit={handleSearchSubmit}
            mode={'search'}
        />
    )
}

export default SearchNetworkProvider